import { useTranslation } from 'react-i18next';

export default function ErrorBanner({ error, fallback }) {
    const { t } = useTranslation();
    if (!error) return null;
    const message = error?.response?.data?.message || error?.message || fallback || t('common.somethingWrong');
    return <div className="error-banner">{message}</div>;
}
